export const MEGAMINX_FACES = [
    // Front
    "U",
    "R",
    "F",
    "dr",
    "dl",
    "L",
    // Back
    "d",
    "br",
    "BR",
    "BL",
    "bl",
    "b",
];
